export default __webpack_public_path__ + "static/media/nx.b89a654d.png";